import { z } from 'zod';

export const UserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string().min(2),
  role: z.enum(['admin', 'teacher']),
  is_active: z.boolean(),
  subscription_plan: z.enum(['free', 'basic', 'premium']),
  subscription_expires_at: z.string().optional(),
  created_at: z.string(),
});

export const TurmaSchema = z.object({
  id: z.string().uuid().optional(),
  user_id: z.string().uuid(),
  name: z.string().min(3, 'Nome da turma deve ter pelo menos 3 caracteres'),
  description: z.string().optional(),
  year: z.number().int().min(2000).max(2100),
  turno: z.enum(['matutino', 'vespertino', 'noturno', 'integral']),
});

export const AlunoSchema = z.object({
  id: z.string().uuid().optional(),
  turma_id: z.string().uuid(),
  name: z.string().min(3, 'Nome do aluno deve ter pelo menos 3 caracteres'),
  registration_number: z.string().optional(),
  sequence_number: z.number().int().positive(),
  email: z.string().email().optional().or(z.literal('')),
});

export const QuestionSchema = z.object({
  number: z.number().int().positive(),
  text: z.string().min(1),
  type: z.enum(['multiple_choice', 'true_false']),
  options: z.array(z.string()).optional(),
  correct_answer: z.string().min(1),
  explanation: z.string().optional(),
});

export const ProvaSchema = z.object({
  id: z.string().uuid().optional(),
  user_id: z.string().uuid(),
  turma_id: z.string().uuid(),
  title: z.string().min(3),
  description: z.string().optional(),
  source_content: z.string().optional(),
  qr_code_data: z.string().optional(),
  status: z.enum(['draft', 'published', 'archived']),
  tipo: z.enum(['individual', 'dupla']).optional(),
  questions: z.array(QuestionSchema).optional(),
});

export const AuthLoginSchema = z.object({
  email: z.string().email('E-mail inválido'),
  password: z.string().min(6, 'Senha deve ter pelo menos 6 caracteres'),
});

export const AuthRegisterSchema = AuthLoginSchema.extend({
  name: z.string().min(2, 'Nome deve ter pelo menos 2 caracteres'),
});
